import { ProfilingRequestSource } from 'clickNgo/configs/profiling/common'
import { IPartner } from 'clickNgo/entities/partner/models'
import { I502Form } from 'clickNgo/models/crud/forms/i502Form'

export const map502FromPartner = (partner: Partial<IPartner>): Partial<I502Form> => {
  return {
    CompanyEnglishName: partner.companyEnglishName,
    CompanyLegalName: partner.companyLegalName,
    CompanyLegalNameNonLatin: partner.companyLegalNameNonLatin,
    EntryId: partner.entryId502 || partner.entryId,
    LegalAddr1: partner.legalAddressLine1,
    LegalAddr2: partner.legalAddressLine2,
    LegalAddr3: partner.legalAddressLine3,
    LegalApproverComment: partner.legalApproverComment,
    LegalCity: partner.legalCity,
    LegalCountry: partner.legalCountry,
    LegalModified: partner.legalModified,
    LegalModifiedValues: partner.legalModifiedValues,
    LegalPostalCode: partner.legalZipCode,
    LegalProfilingComment: partner.legalProfilingComment,
    LegalState: partner.legalState,
    LegalWorkflowStatus: partner.legalWorkflowStatus,
    Market: partner.market,
    PartnerID: partner.partnerId,
    Source: partner.source || ProfilingRequestSource.ClickAndGo,
  }
}
